// source: galaxycompletepb/apipb/domainpb/azure.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var galaxymigratepb_galaxy_migrate_autoalloc_pb = require('../../../galaxymigratepb/galaxy_migrate_autoalloc_pb.js');
goog.object.extend(proto, galaxymigratepb_galaxy_migrate_autoalloc_pb);
goog.exportSymbol('proto.galaxycomplete.domain.AzureStorageProduct', null, global);
goog.exportSymbol('proto.galaxycomplete.domain.AzureStorageRecommendation', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.galaxycomplete.domain.AzureStorageProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.galaxycomplete.domain.AzureStorageProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.galaxycomplete.domain.AzureStorageProduct.displayName = 'proto.galaxycomplete.domain.AzureStorageProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.galaxycomplete.domain.AzureStorageRecommendation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.galaxycomplete.domain.AzureStorageRecommendation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.galaxycomplete.domain.AzureStorageRecommendation.displayName = 'proto.galaxycomplete.domain.AzureStorageRecommendation';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.galaxycomplete.domain.AzureStorageProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.galaxycomplete.domain.AzureStorageProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.galaxycomplete.domain.AzureStorageProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.galaxycomplete.domain.AzureStorageProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    storageType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    maxCapacity: jspb.Message.getFieldWithDefault(msg, 3, 0),
    maxThroughput: jspb.Message.getFieldWithDefault(msg, 4, 0),
    maxIops: jspb.Message.getFieldWithDefault(msg, 5, 0),
    usableAsOsDisk: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.galaxycomplete.domain.AzureStorageProduct}
 */
proto.galaxycomplete.domain.AzureStorageProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.galaxycomplete.domain.AzureStorageProduct;
  return proto.galaxycomplete.domain.AzureStorageProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.galaxycomplete.domain.AzureStorageProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.galaxycomplete.domain.AzureStorageProduct}
 */
proto.galaxycomplete.domain.AzureStorageProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {!proto.galaxymigrate.AutoAlloc.VolumeParams.Azure.StorageType} */ (reader.readEnum());
      msg.setStorageType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMaxCapacity(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMaxThroughput(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMaxIops(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUsableAsOsDisk(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.galaxycomplete.domain.AzureStorageProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.galaxycomplete.domain.AzureStorageProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.galaxycomplete.domain.AzureStorageProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.galaxycomplete.domain.AzureStorageProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStorageType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getMaxCapacity();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getMaxThroughput();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getMaxIops();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getUsableAsOsDisk();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.galaxycomplete.domain.AzureStorageProduct.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.galaxycomplete.domain.AzureStorageProduct} returns this
 */
proto.galaxycomplete.domain.AzureStorageProduct.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional galaxymigrate.AutoAlloc.VolumeParams.Azure.StorageType storage_type = 2;
 * @return {!proto.galaxymigrate.AutoAlloc.VolumeParams.Azure.StorageType}
 */
proto.galaxycomplete.domain.AzureStorageProduct.prototype.getStorageType = function() {
  return /** @type {!proto.galaxymigrate.AutoAlloc.VolumeParams.Azure.StorageType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.galaxymigrate.AutoAlloc.VolumeParams.Azure.StorageType} value
 * @return {!proto.galaxycomplete.domain.AzureStorageProduct} returns this
 */
proto.galaxycomplete.domain.AzureStorageProduct.prototype.setStorageType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional uint64 max_capacity = 3;
 * @return {number}
 */
proto.galaxycomplete.domain.AzureStorageProduct.prototype.getMaxCapacity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.galaxycomplete.domain.AzureStorageProduct} returns this
 */
proto.galaxycomplete.domain.AzureStorageProduct.prototype.setMaxCapacity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 max_throughput = 4;
 * @return {number}
 */
proto.galaxycomplete.domain.AzureStorageProduct.prototype.getMaxThroughput = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.galaxycomplete.domain.AzureStorageProduct} returns this
 */
proto.galaxycomplete.domain.AzureStorageProduct.prototype.setMaxThroughput = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint64 max_iops = 5;
 * @return {number}
 */
proto.galaxycomplete.domain.AzureStorageProduct.prototype.getMaxIops = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.galaxycomplete.domain.AzureStorageProduct} returns this
 */
proto.galaxycomplete.domain.AzureStorageProduct.prototype.setMaxIops = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool usable_as_os_disk = 6;
 * @return {boolean}
 */
proto.galaxycomplete.domain.AzureStorageProduct.prototype.getUsableAsOsDisk = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.galaxycomplete.domain.AzureStorageProduct} returns this
 */
proto.galaxycomplete.domain.AzureStorageProduct.prototype.setUsableAsOsDisk = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.prototype.toObject = function(opt_includeInstance) {
  return proto.galaxycomplete.domain.AzureStorageRecommendation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.galaxycomplete.domain.AzureStorageRecommendation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.toObject = function(includeInstance, msg) {
  var f, obj = {
    product: (f = msg.getProduct()) && proto.galaxycomplete.domain.AzureStorageProduct.toObject(includeInstance, f),
    capacity: jspb.Message.getFieldWithDefault(msg, 4, 0),
    throughput: jspb.Message.getFieldWithDefault(msg, 5, 0),
    iops: jspb.Message.getFieldWithDefault(msg, 6, 0),
    pricePerMonth: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.galaxycomplete.domain.AzureStorageRecommendation}
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.galaxycomplete.domain.AzureStorageRecommendation;
  return proto.galaxycomplete.domain.AzureStorageRecommendation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.galaxycomplete.domain.AzureStorageRecommendation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.galaxycomplete.domain.AzureStorageRecommendation}
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.galaxycomplete.domain.AzureStorageProduct;
      reader.readMessage(value,proto.galaxycomplete.domain.AzureStorageProduct.deserializeBinaryFromReader);
      msg.setProduct(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCapacity(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setThroughput(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setIops(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPricePerMonth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.galaxycomplete.domain.AzureStorageRecommendation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.galaxycomplete.domain.AzureStorageRecommendation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.galaxycomplete.domain.AzureStorageProduct.serializeBinaryToWriter
    );
  }
  f = message.getCapacity();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getThroughput();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getIops();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getPricePerMonth();
  if (f !== 0.0) {
    writer.writeFloat(
      20,
      f
    );
  }
};


/**
 * optional AzureStorageProduct product = 1;
 * @return {?proto.galaxycomplete.domain.AzureStorageProduct}
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.prototype.getProduct = function() {
  return /** @type{?proto.galaxycomplete.domain.AzureStorageProduct} */ (
    jspb.Message.getWrapperField(this, proto.galaxycomplete.domain.AzureStorageProduct, 1));
};


/**
 * @param {?proto.galaxycomplete.domain.AzureStorageProduct|undefined} value
 * @return {!proto.galaxycomplete.domain.AzureStorageRecommendation} returns this
*/
proto.galaxycomplete.domain.AzureStorageRecommendation.prototype.setProduct = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.galaxycomplete.domain.AzureStorageRecommendation} returns this
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.prototype.clearProduct = function() {
  return this.setProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.prototype.hasProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint64 capacity = 4;
 * @return {number}
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.prototype.getCapacity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.galaxycomplete.domain.AzureStorageRecommendation} returns this
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.prototype.setCapacity = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint64 throughput = 5;
 * @return {number}
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.prototype.getThroughput = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.galaxycomplete.domain.AzureStorageRecommendation} returns this
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.prototype.setThroughput = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint64 iops = 6;
 * @return {number}
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.prototype.getIops = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.galaxycomplete.domain.AzureStorageRecommendation} returns this
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.prototype.setIops = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional float price_per_month = 20;
 * @return {number}
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.prototype.getPricePerMonth = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.galaxycomplete.domain.AzureStorageRecommendation} returns this
 */
proto.galaxycomplete.domain.AzureStorageRecommendation.prototype.setPricePerMonth = function(value) {
  return jspb.Message.setProto3FloatField(this, 20, value);
};


goog.object.extend(exports, proto.galaxycomplete.domain);
